import { apiFetch } from "./fetchApi"

export const fetchNotification = (setGetNotification, BeURL, showAlert, perPage = 1, currentPage = 1, setTotalPages, setTotalCount) => {

    apiFetch(`${BeURL}/fetch-notification`, {
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({ perPage, currentPage })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success === true) {
                setGetNotification(data?.notifications)
                setTotalPages(data?.totalPage || 1)
                setTotalCount(data?.totalCount || 0)
            }
            else {
                showAlert(data.message)
                setGetNotification([])
            }
        })
        .catch(err => {
            console.log("Error while get notification:", err);
            alert("Unable to get notifiation. Please try again later.");
        })

}

export const readNotification = (id, BeURL) => {
    if (!id || !BeURL) {
        return;
    }

    apiFetch(`${BeURL}/ticket-read-status`, {
        method: 'PUT',
        credentials: 'include',
        body: JSON.stringify({ id })
    })
        .then(res => res.json())
        .then(data => {
            if (data?.success === true) {
                alert(data.message)
                window.location.reload()
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error while raising ticket:", err);
            alert("Unable to raise ticket. Please try again later.");
        })
}

export const readAllNotification = (id, BeURL) => {
    apiFetch(`${BeURL}/ticket-read-status-all`, {
        method: 'PUT',
        credentials: 'include',
        body: JSON.stringify({ id })
    })
        .then(res => res.json())
        .then(data => {
            if (data?.success === true) {
                alert(data.message)
                window.location.reload()
            }
            else {
                alert(data.message)
            }
        })
        .catch(err => {
            console.log("Error while raising ticket:", err);
            alert("Unable to raise ticket. Please try again later.");
        })
}

export const notificationCount = async (BeURL, showAlert) => {

    if (!BeURL) {
        showAlert("Backend URL missing");
        return { success: false };
    }

    try {
        const res = await apiFetch(`${BeURL}/fetch-notification-count`, {
            credentials: "include",
            method: "GET"
        });

        const data = await res.json();

        if (!data.success) {
            showAlert(data.message || "Failed to fetch notification count");
            return { success: false };
        }

        return {
            success: true,
            count: data.count   // ✅ IMPORTANT
        };

    } catch (error) {
        console.error("Notification Count Error:", error);
        showAlert("Server error while fetching notification count");
        return { success: false };
    }
};